import React, { PropsWithChildren, useMemo } from "react";
import { Platform, View, ViewStyle } from "react-native";
import Animated, {
  useAnimatedStyle,
  withTiming,
} from "react-native-reanimated";

export function MovingHorizontalContainer(
  props: PropsWithChildren<{ bottom: number; animated?: boolean }>
) {
  return Platform.OS === "web" || props.animated === false ? (
    <NonAnimatedMovingHorizontalContainer {...props} />
  ) : (
    <AnimatedMovingHorizontalContainer {...props} />
  );
}

function AnimatedMovingHorizontalContainer(
  props: PropsWithChildren<{ bottom: number }>
) {
  const style = useAnimatedStyle(
    () => ({
      transform: [{ translateY: withTiming(-props.bottom) }],
      flex: 1,
      bottom: 0,
      marginBottom: -21,
      height: 40,
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      position: "absolute",
    }),
    [props.bottom]
  );
  return <Animated.View style={style}>{props.children}</Animated.View>;
}

function NonAnimatedMovingHorizontalContainer(
  props: PropsWithChildren<{ bottom: number }>
) {
  const style = useMemo<ViewStyle>(
    () => ({
      flex: 1,
      bottom: props.bottom,
      marginBottom: -21,
      height: 40,
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      position: "absolute",
    }),
    [props.bottom]
  );
  return <View style={style}>{props.children}</View>;
}
